import Provider from './src/context/context'

export const wrapRootElement = Provider